module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FWPQx0/images/cover.jpg?1685327562543",
      "alt": "This image is the cover for the book Then the Stars Fall"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Then the Stars Fall\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The death of his wife four years earlier left Travis Bennett a shell of the man he used to be. With his dog by his side, Travis raises his three children, manages his business, and works as a ranch hand. But every day, every minute, is an aching emptiness.")]), _vm._v(" "), _c('p', [_vm._v("Wesley Ryan has fond memories of the small Ozark town of El Dorado. Seeing it as a safe place to put his failed relationships behind him, Wesley moves into his grandparents’ old home and takes over the local veterinary clinic. An early morning visit from Travis and his dog stirs feelings that Wesley seeks to push away—the last thing he needs is to fall for a man with baggage and three kids as part of the package.")]), _vm._v(" "), _c('p', [_vm._v("Life, it seems, has other plans.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brandon Witt\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0